import Experience from "../../components/Experience/Experience";
import AboutUsHelmetComponent from "./AboutUsHelmetComponent";
import Team from "../../components/Team/Team";
import Stage from "../../assets/new_logo.webp";

const aboutHighlights = [
  "Kerava",
  "Äänentoisto",
  "Valotekniikka",
  "Kuljetus & asennus",
];

const AboutUs = () => {
  return (
    <main
      className="
        relative w-full overflow-hidden pt-16 pb-20
        bg-gradient-to-br from-white via-[#F3FFFC] to-[#E9FBF7]
        text-[#111827]
        dark:from-[#050505] dark:via-[#08080A] dark:to-[#0D0D12]
        dark:text-white
      "
    >
      <AboutUsHelmetComponent />

      {/* Taustakoristeet */}
      <div
        aria-hidden="true"
        className="
          pointer-events-none absolute left-1/2 top-10 h-72 w-72
          -translate-x-1/2 rounded-full bg-primary/15 blur-3xl
          dark:bg-primary/10
        "
      />

      <div
        aria-hidden="true"
        className="
          pointer-events-none absolute -right-24 top-72 h-80 w-80
          rounded-full bg-[#30f2cf]/10 blur-3xl
          dark:bg-primary/10
        "
      />

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* HERO */}
        <section
          className="
            overflow-hidden rounded-[2rem] border border-[#DDE7E5]
            bg-white/90 p-6 shadow-xl backdrop-blur-xl
            dark:border-darkborder dark:bg-[#111114]/95
            sm:p-8 lg:p-10
          "
        >
          <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-[1.25fr_0.75fr]">
            {/* Teksti */}
            <div>
              <span
                className="
                  mb-5 inline-flex rounded-full border border-primary/40 bg-primary/10
                  px-4 py-1.5 font-customFont1 text-xs font-extrabold uppercase
                  tracking-[0.14em] !text-[#111827] shadow-sm
                  dark:!text-white
                "
                data-aos="fade-in"
                data-aos-duration="1200"
              >
                Spiderlegs Productions
              </span>

              <h1
                className="
                  font-customFont2 text-5xl font-bold uppercase leading-none
                  !text-[#111827]
                  dark:!text-white
                  sm:text-6xl lg:text-7xl
                "
                data-aos="fade-in"
                data-aos-duration="1600"
              >
                Tapahtumatekniikkaa Keravalta
              </h1>

              <p
                className="
                  mt-6 max-w-3xl font-customFont1 text-lg leading-relaxed
                  !text-[#374151]
                  dark:!text-[#D1D5DB]
                  sm:text-xl
                "
                data-aos="fade-up"
                data-aos-duration="1800"
              >
                <strong className="font-extrabold !text-[#111827] dark:!text-white">
                  Spiderlegs Productions
                </strong>{" "}
                on Keravalla toimiva tapahtumatekniikan, äänentoiston,
                valotekniikan ja laitevuokrauksen palvelu. Autamme tekemään
                tilaisuuksista teknisesti sujuvia, selkeitä ja luotettavasti
                toteutettuja.
              </p>

              <div className="mt-7 flex flex-wrap gap-3">
                {aboutHighlights.map((item) => (
                  <span
                    key={item}
                    className="
                      rounded-full border border-[#DDE7E5] bg-[#F8FAFC]
                      px-4 py-2 font-customFont1 text-sm font-bold
                      !text-[#111827] shadow-sm
                      dark:border-darkborder dark:bg-darksurface dark:!text-white
                    "
                  >
                    {item}
                  </span>
                ))}
              </div>
            </div>

            {/* Logokortti */}
            <div
              className="
                relative mx-auto flex aspect-square w-full max-w-sm items-center justify-center
                rounded-[2rem] border border-[#DDE7E5]
                bg-gradient-to-br from-[#F8FAFC] via-white to-[#E9FBF7]
                p-10 shadow-inner
                dark:border-darkborder dark:from-[#16161A] dark:via-[#111114] dark:to-[#0A0A0D]
              "
              data-aos="zoom-in"
              data-aos-duration="1400"
            >
              <div
                aria-hidden="true"
                className="
                  absolute inset-8 rounded-full bg-primary/10 blur-2xl
                  dark:bg-primary/10
                "
              />

              <img
                src={Stage}
                alt="Spiderlegs Productionsin logo"
                loading="lazy"
                className="relative z-10 h-auto w-48 object-contain sm:w-56"
              />
            </div>
          </div>
        </section>

        {/* Sisältö */}
        <section className="mt-10 grid grid-cols-1 gap-10 lg:grid-cols-[1.1fr_0.9fr]">
          {/* Tekstikortti */}
          <article
            className="
              rounded-[2rem] border border-[#DDE7E5]
              bg-white/90 p-6 shadow-xl backdrop-blur-xl
              dark:border-darkborder dark:bg-[#111114]/95
              sm:p-8
            "
          >
            <h2
              className="
                mb-5 font-customFont2 text-4xl font-bold uppercase leading-none
                !text-[#111827]
                dark:!text-white
                sm:text-5xl
              "
            >
              Meistä
            </h2>

            <div
              className="
                space-y-5 font-customFont1 text-lg leading-relaxed
                !text-[#374151]
                dark:!text-[#D1D5DB]
                sm:text-xl
              "
            >
              <p>
                <strong className="font-extrabold !text-[#111827] dark:!text-white">
                  Spiderlegs Productions
                </strong>{" "}
                on Keravalla toimiva tapahtumatekniikan ja
                äänentoistopalveluiden tarjoaja. Toiminta-alueemme kattaa
                pääasiassa Etelä-Suomen, ja palvelemme yksityisasiakkaita,
                yrityksiä sekä yhteisöjä erilaisissa tilaisuuksissa.
              </p>

              <p>
                Tarjoamme äänentoiston, esitystekniikan ja tunnelmavalaistuksen
                vuokrausta tapahtumiin, joissa toimiva ja luotettava tekniikka
                on keskiössä. Palvelumme sopivat esimerkiksi juhliin,
                yritystapahtumiin, kokouksiin ja muihin tilaisuuksiin, joissa
                halutaan varmistaa sujuva tekninen toteutus.
              </p>

              <p>
                Spiderlegs Productionsin taustalla on myös omaa
                palvelukehitystä. Yritys on kehittänyt{" "}
                <a
                  href="https://buukkeri.fi/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="
                    font-extrabold !text-[#111827] underline decoration-primary decoration-2
                    underline-offset-4 transition hover:!text-primary
                    dark:!text-white dark:hover:!text-primary
                  "
                >
                  Buukkeri.fi
                </a>
                -palvelun, joka toimii erillisenä omana kokonaisuutenaan
                tapahtumapalveluiden etsimiseen ja varaamiseen.
                Spiderlegs Productions -sivusto keskittyy erikseen
                tapahtumatekniikan vuokraukseen, kuljetuksiin, asennuksiin ja
                käytön opastukseen.
              </p>
            </div>
          </article>

          {/* Info-kortti */}
          <aside
            className="
              rounded-[2rem] border border-primary/30 bg-primary/10 p-6 shadow-xl
              dark:border-primary/30 dark:bg-primary/5 dark:shadow-none
              sm:p-8
            "
          >
            <span
              className="
                mb-4 inline-flex rounded-full border border-primary/40 bg-white
                px-3 py-1 font-customFont1 text-xs font-extrabold uppercase
                tracking-[0.12em] !text-[#111827]
                dark:bg-darksurface dark:!text-white
              "
            >
              Mitä teemme?
            </span>

            <h2
              className="
                font-customFont2 text-4xl font-bold uppercase leading-none
                !text-[#111827]
                dark:!text-white
                sm:text-5xl
              "
            >
              Tekniikka helposti mukaan tapahtumaan
            </h2>

            <p
              className="
                mt-5 font-customFont1 text-lg leading-relaxed
                !text-[#374151]
                dark:!text-[#D1D5DB]
              "
            >
              Vuokraamme ja toimitamme tapahtumatekniikkaa tilanteisiin, joissa
              halutaan selkeä, toimiva ja käytännönläheinen ratkaisu ilman
              turhaa säätöä.
            </p>

            <ul className="mt-6 space-y-3">
              {[
                "Äänentoisto juhliin ja tilaisuuksiin",
                "Valotekniikka ja tunnelmavalaistus",
                "Kuljetus, asennus ja käytön opastus",
                "Ratkaisut yksityisille, yrityksille ja yhteisöille",
              ].map((item) => (
                <li
                  key={item}
                  className="
                    flex gap-3 font-customFont1 text-base font-semibold
                    !text-[#111827]
                    dark:!text-white
                  "
                >
                  <span className="mt-2 h-2 w-2 shrink-0 rounded-full bg-primary" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </aside>
        </section>

        {/* Tiimi */}
        <section className="mt-12">
          <Team />
        </section>

        {/* Kokemus / referenssit */}
        <section className="mt-12">
          <Experience />
        </section>
      </div>
    </main>
  );
};

export default AboutUs;